import React from 'react';
import { DATA_TEST_IDS } from '../consts';
import type { MediafileFieldsProps } from './types';
import styles from '../index.module.scss';

export const MediafileFields: React.FC<MediafileFieldsProps> = ({ id, fields }) => (
  <div
    className={styles.fields}
    data-testid={DATA_TEST_IDS.FIELDS(id)}>
    {fields.map(({ id: fieldId, control }) => (
      <div
        key={fieldId}
        className={styles.field}>
        {control}
      </div>
    ))}
  </div>
);
